import { useQuery } from '@tanstack/react-query';
import type { AgentApiCompaniesIndex } from '@/types/serializers';

/**
 * KPI カード用に「稼動企業」の総件数のみを取得する軽量フック。
 * companies index API を 1 ページ目だけ叩き、`total_count` のみ参照する。
 */
export default function useFetchCompanyCount() {
  return useQuery({
    queryKey: ['/agent/api/companies', 'count'],
    queryFn: async () => {
      const response = await fetch('/agent/api/companies.json?page=1');
      if (!response.ok) {
        throw new Error('稼動企業数の取得に失敗しました');
      }
      const data: AgentApiCompaniesIndex = await response.json();
      return data.total_count;
    },
  });
}
